"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStepsContext = exports.StepsProvider = exports.useSteps = exports.Step = exports.Steps = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const framer_motion_1 = require("framer-motion");
const react_2 = require("@chakra-ui/react");
const __1 = require("..");
const MotionCenter = (0, framer_motion_1.motion)(react_2.Center);
function Steps({ children }) {
    const { activeStep } = useStepsContext();
    const steps = react_1.default.Children.toArray(children);
    const stepCount = steps.length;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: react_1.default.Children.map(children, (child, i) => {
            var _a;
            const isCompletedStep = (_a = (react_1.default.isValidElement(child) && child.props.isCompletedStep)) !== null && _a !== void 0 ? _a : i < activeStep;
            const isLastStep = i === stepCount - 1;
            const isCurrentStep = i === activeStep;
            const stepProps = {
                activeStep,
                index: i,
                isCompletedStep,
                isCurrentStep,
                isLastStep,
            };
            if (react_1.default.isValidElement(child)) {
                return react_1.default.cloneElement(child, stepProps);
            }
            return null;
        }) }));
}
exports.Steps = Steps;
const animationConfig = {
    transition: {
        duration: 0.25,
    },
    exit: { scale: 0.5, opacity: 0 },
    initial: { scale: 0.5, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
};
const centerProps = {
    rounded: "full",
    boxSize: 8,
};
function Step({ activeStep, isCompletedStep, index, label, children, }) {
    const isActive = activeStep === index;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_2.Box, Object.assign({ display: "flex", alignItems: "center", flex: "1", textAlign: "left", gap: 4, p: 2 }, { children: [isCompletedStep ? ((0, jsx_runtime_1.jsx)(MotionCenter, Object.assign({}, centerProps, animationConfig, { bgColor: "gray.100" }, { children: (0, jsx_runtime_1.jsx)(__1.CheckIcon, { boxSize: 5, color: "green.500" }) }))) : ((0, jsx_runtime_1.jsx)(react_2.Center, Object.assign({ bgColor: isActive ? "brand.teal.500" : "gray.100", color: isActive ? "white" : "brand.black" }, centerProps, { children: (index || 0) + 1 }))), label] })), (0, jsx_runtime_1.jsx)(react_2.Collapse, Object.assign({ in: activeStep === index }, { children: (0, jsx_runtime_1.jsx)(react_2.Box, Object.assign({ pb: 4 }, { children: children })) }))] }));
}
exports.Step = Step;
function useSteps({ initialStep }) {
    const [activeStep, setActiveStep] = react_1.default.useState(initialStep);
    const nextStep = () => {
        setActiveStep(prev => prev + 1);
    };
    const prevStep = () => {
        setActiveStep(prev => prev - 1);
    };
    const reset = () => {
        setActiveStep(initialStep);
    };
    const setStep = (step) => {
        setActiveStep(step);
    };
    return { nextStep, prevStep, reset, setStep, activeStep };
}
exports.useSteps = useSteps;
const StepsContext = react_1.default.createContext({
    activeStep: 0,
    prevStep: () => { },
    reset: () => { },
    setStep: () => { },
    nextStep: () => { },
});
function StepsProvider({ value, children, }) {
    return (0, jsx_runtime_1.jsx)(StepsContext.Provider, Object.assign({ value: value }, { children: children }));
}
exports.StepsProvider = StepsProvider;
function useStepsContext() {
    return react_1.default.useContext(StepsContext);
}
exports.useStepsContext = useStepsContext;
